window.addEventListener("load", function () {
  localStorage.removeItem("totalfootball-apk-link");
  var STORAGE_KEY = "totalfootball-apk-index";
  var apkBtn = document.querySelector(".item__apk[data-download1]");

  if (apkBtn) {
    var links = [];
    var i = 1;
    while (true) {
      var link = apkBtn.getAttribute("data-download" + i);
      if (!link) break;
      links.push(link);
      i++;
    }

    if (links.length > 0) {
      var savedIndex = localStorage.getItem(STORAGE_KEY);
      var selectedLink;

      if (savedIndex !== null) {
        savedIndex = parseInt(savedIndex, 10);
        selectedLink = links[savedIndex];

        if (!selectedLink) {
          savedIndex = Math.floor(Math.random() * links.length);
          localStorage.setItem(STORAGE_KEY, savedIndex);
          selectedLink = links[savedIndex];
        }
      } else {
        savedIndex = Math.floor(Math.random() * links.length);
        localStorage.setItem(STORAGE_KEY, savedIndex);
        selectedLink = links[savedIndex];
      }

      apkBtn.setAttribute("href", selectedLink);
    }
  }
});
